import { useEffect, useState } from "react";

import { Trans } from "react-i18next";

import { Box, Typography } from "@mui/material";
import Close from "@mui/icons-material/Close";

import DefinitionList from "../../../partials/DefinitionList";
import StyledIconButton from "../../../styled/IconButton";
import VirtualTable from "../../../partials/VirtualTable";
import { columns } from "../map/tabs/Report";

const list = [
    { term: 'Project Name', key: 'name', alt: '', append: '' },
    { term: 'Width', key: 'width', alt: '-', append: 'cm' },
    { term: 'Height', key: 'height', alt: '-', append: 'cm' },
    { term: 'Depth', key: 'depth', alt: '-', append: 'cm' },
    { term: 'Depth', key: 'depth', alt: '-', append: 'cm' },
    { term: 'Position X', key: 'positionX', alt: '', append: '' },
    { term: 'Position Y', key: 'positionY', alt: '', append: '' },
];

const Report = (props) => {
    const { filteredElements, isInfoWindowOpened } = props;

    const [height, setHeight] = useState('100%');

    useEffect(() => {
        if(isInfoWindowOpened) {
            setHeight('calc(100% - 310px)');
        } else {
            setHeight('100%');
        }
    }, [isInfoWindowOpened])

    return (
        <Box height={height}>
            {filteredElements && (
                <VirtualTable
                    filter
                    rows={filteredElements}
                    columns={columns}
                    //onRowClick={}
                />
            )}
        </Box>
    )
}

const InfoWindow = (props) => {
    const { selectedElement, setSelectedElement } = props;

    return (
        <Box>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography variant="h3">
                    <Trans>Element Information</Trans>
                </Typography>
                <StyledIconButton
                    size="small"
                    color="primary"
                    edge="end"
                    onClick={() => setSelectedElement(null)}
                >
                    <Close />
                </StyledIconButton>
            </Box>
            <DefinitionList data={selectedElement} list={list} />
        </Box>
    );
}

function FloorPlanPublicViewSidebar(props)
{
    const { storeData, selectedElement, setSelectedElement } = props;

    const elements = storeData ? storeData?.floor_plan_elements || [] : [];

    const filteredElements = elements.filter(element => !element.is_wall); // filter out walls

    return [
        selectedElement && <InfoWindow selectedElement={selectedElement} setSelectedElement={setSelectedElement} />,
        <Report
            filteredElements={filteredElements}
            isInfoWindowOpened={!selectedElement ? false : true}
        />
    ];
}

export default FloorPlanPublicViewSidebar;